import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../store';

export interface RFXRequestWizardState {
  generalInfomationValidationError: string;
}

const initialState: RFXRequestWizardState = {
  generalInfomationValidationError: ''
};

const rfxRequestWizardSlice = createSlice({
  name: 'rfxRequestWizard',
  initialState,
  reducers: {
    setGeneralInformationValidationError(state, action: PayloadAction<string>) {
      state.generalInfomationValidationError = action.payload;
    }
  }
});

export const { setGeneralInformationValidationError } = rfxRequestWizardSlice.actions;

export const selectGeneralInformationValidationError = (state: RootState): string => {
  return state.rfxRequestWizard.generalInfomationValidationError;
};

export const selectGeneralInformationHasValidationError = (state: RootState): boolean => {
  return state.rfxRequestWizard.generalInfomationValidationError !== '';
};

export default rfxRequestWizardSlice.reducer;
